import { shareInFlight } from '@/pure/in-flight';
import { fetchAllPages, pageFromBody, PageRequest, PageResult } from '@/pure/problemsPaging';
import { IJoinedProblem } from '@/types';

/** The many components that dispatch this at once share one page loop. */
const loadAllPages = shareInFlight(async ({ commit, getters }: any) => {
  const fetchPage = async (request: PageRequest): Promise<PageResult<IJoinedProblem>> => {
    try {
      const response = await getters.apiGet('trainingSystem/problems', { params: request });
      return pageFromBody(response.data);
    } catch (e) {
      console.log(e);
      return { isOk: false, message: e instanceof Error ? e.message : String(e) };
    }
  };
  const result = await fetchAllPages(fetchPage);
  if (result.isOk) {
    commit('loadJoinedProblems', result.rows);
    return;
  }
  commit('pushFlash', {
    title: 'There was an error while fetching Training System problems:',
    message: result.message,
    variant: 'warning',
    duration: 4000,
  });
});

export default async function fetchJoinedProblems(context: any) {
  if (context.state.joinedProblems.length > 1) return;
  await loadAllPages(context);
}
